var Editable;

Editable = function(self, property, change) {
  var editing_property;
  editing_property = 'editing_' + property;
  Observable(self, property);
  Observable(self, editing_property, self[property]() === '' || (self[property]() == null));
  self[property].subscribe((function(_this) {
    return function(new_value) {
      var r;
      r = change(new_value, property);
      if (r !== true) {
        return self[editing_property](false);
      }
    };
  })(this));
  self['edit_' + property] = (function(_this) {
    return function() {
      return self[editing_property](true);
    };
  })(this);
  return self;
};

//# sourceMappingURL=editable.js.map
